import axios from 'axios';
import { useSnackbar, OptionsObject } from 'notistack';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

let AxiosInterceptors = () => {
    let { enqueueSnackbar } = useSnackbar();
    let { formatMessage } = useIntl();
    let location = useLocation();


    axios.interceptors.response.use(
        response => response,

        error => {
            let { data, status } = error.response;

            let options: OptionsObject = {
                variant: 'error',
                autoHideDuration: 4000
            }

            switch (status) {
                case 400:
                    if (data.HasErrors) {
                        data.Errors.forEach((er: string) => enqueueSnackbar(formatMessage({ id: er }), options));
                    } else {
                        for (let i in data.errors)
                            enqueueSnackbar(formatMessage({ id: data.errors[i] }), options);
                    }
                    break;

                case 401:
                    // è giusto /app, location.pathname contiene una / iniziale
                    window.location.href = `/Identity/Account/Login?returnUrl=/app${location.pathname}`;
                    break;

                case 404:
                    // do nothing
                    break;

                case 500:
                    enqueueSnackbar('Internal server error', options);
                    break;

                default:
                    enqueueSnackbar('Unable to connect to server, please check your internet connection and retry.', options);
                    break;
            }

            return Promise.reject({ ...data });
        }
    )

    return (null);
}

export default AxiosInterceptors;